import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowLeftIcon } from 'lucide-react';
import { bestSellers } from '../../data/bestSellers';
import { WhatsAppButton } from '../WhatsAppButton';
const ease = [0.23, 1, 0.32, 1] as const;
interface BrandCoverProps {
  slug: string;
  name: string;
  tagline: string;
  modelsCount: number;
  versionsCount: number;
}
export function BrandCover({
  slug,
  name,
  tagline,
  modelsCount,
  versionsCount
}: BrandCoverProps) {
  const star = bestSellers.find(b => b.slug === slug);
  return <section className="relative overflow-hidden border-b border-neon/40" data-id="element-393" data-mp="3mo32gv6uetxn">
      {star && <motion.img key={star.image} src={star.image} alt={`${name} ${star.model}`} className="absolute inset-0 h-full w-full object-cover object-center" initial={{
      scale: 1.12
    }} animate={{
      scale: 1
    }} transition={{
      duration: 8,
      ease: 'linear'
    }} data-id="element-394" data-mp="3imhjcs3ptjf0" />}
      <div className="absolute inset-0 bg-ink/70 md:bg-ink/55" aria-hidden data-id="element-395" data-mp="3v4co1w10u22r" />
      <div className="absolute inset-y-0 left-0 w-full bg-ink/40 md:w-1/2" aria-hidden data-id="element-396" data-mp="3x063esbdkls" />
      <span className="absolute inset-x-0 bottom-0 h-0.5 bg-neon-hi" style={{
      boxShadow: '0 0 14px #1463FF'
    }} aria-hidden data-id="element-397" data-mp="8wcuw52qx1r0" />

      <div className="container-x relative flex min-h-[260px] flex-col justify-center py-8 sm:min-h-[300px]" data-id="element-398" data-mp="cy6s23dqfnmf">
        <Link to="/marcas" className="inline-flex w-fit items-center gap-1.5 text-sm text-silver hover:text-white" data-id="element-399" data-mp="hvzz0ymv0lnr">
          <ArrowLeftIcon className="h-4 w-4" aria-hidden data-id="element-400" data-mp="mujjeult1pe0" /> Marcas
        </Link>
        <motion.p initial={{
        opacity: 0,
        x: -12
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.3,
        ease
      }} className="mt-4 text-xs font-bold tracking-[0.3em] text-neon-hi" data-id="element-401" data-mp="rnvxiasuydsi">
          {name.toUpperCase()} {star ? `· ${star.model.toUpperCase()}` : ''}
        </motion.p>
        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease,
        delay: 0.08
      }} className="text-metal mt-2 max-w-2xl font-display text-4xl font-black leading-[0.98] tracking-tight sm:text-5xl lg:text-6xl" data-id="element-402" data-mp="15m2n73nnl7h3">
          {star?.tagline ?? tagline}
        </motion.h1>
        <motion.p initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease,
        delay: 0.16
      }} className="mt-3 text-sm text-silver" data-id="element-403" data-mp="3bgli125u57pj">
          {tagline} · {modelsCount} modelos · {versionsCount} versiones 0 km
        </motion.p>
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease,
        delay: 0.24
      }} className="mt-5 flex flex-col gap-2 sm:flex-row" data-id="element-404" data-mp="3gemxze7ysqws">
          <Link to="/simulador" className="btn btn-primary" data-id="element-405" data-mp="3uc1vz7caa70d">Simular financiación</Link>
          <WhatsAppButton extra={`Me interesa la marca ${name}${star ? `, especialmente el ${star.model}` : ''}.`} data-id="element-406" data-mp="3pd8g589iy3x1" />
        </motion.div>
      </div>
    </section>;
}